import { render, staticRenderFns } from "./ProductCenterDetails.vue?vue&type=template&id=c3129376&scoped=true&"
import script from "./ProductCenterDetails.vue?vue&type=script&lang=js&"
export * from "./ProductCenterDetails.vue?vue&type=script&lang=js&"
import style0 from "./ProductCenterDetails.vue?vue&type=style&index=0&id=c3129376&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3129376",
  null
  
)

export default component.exports